// NotificationModal.jsx
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../../styles/manage.css';

function NotificationModal({ isOpen, message, type = 'info', duration = 3000, onClose }) {
  const [visible, setVisible] = useState(false);
  const [content, setContent] = useState('');

  useEffect(() => {
    if (isOpen && message) {
      setContent(message);
      setVisible(true);
      
      // 自动关闭定时器
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(() => {
          if (onClose) onClose();
        }, 300); // 等待动画结束
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, message, duration, onClose]);

  // 手动关闭
  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  };

  // 根据类型获取对应的样式类名
  const getTypeClass = () => {
    switch(type) {
      case 'success': return 'notification-success';
      case 'error': return 'notification-error';
      case 'warning': return 'notification-warning';
      case 'info': 
      default: return 'notification-info';
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={`notification-modal ${getTypeClass()}`}
          initial={{ 
            opacity: 0, 
            y: -100,
            scale: 0.8
          }}
          animate={{ 
            opacity: 1, 
            y: 20,
            scale: 1,
            transition: {
              type: "spring",
              stiffness: 400,
              damping: 25
            }
          }}
          exit={{ 
            opacity: 0, 
            y: -100,
            scale: 0.8,
            transition: { duration: 0.3 }
          }}
          onClick={handleClose}
        >
          <div className="notification-content">

            <div className="notification-message">{content}</div>
            <button className="notification-close" onClick={handleClose}>
              ×
            </button>
          </div>
          
          {/* 进度条 */}
          <motion.div 
            className="notification-progress"
            initial={{ scaleX: 1 }}
            animate={{ 
              scaleX: 0,
              transition: { 
                duration: duration / 1000, 
                ease: "linear" 
              }
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default NotificationModal;